import {
    apioperateFullCommissionApproval,
    apicommissionApplyById
  } from '@/api/sys/Commission'
  export default {
    namespaced: true,
    actions: {
        apioperateFullCommissionApproval(context,data){
            console.log(data);
           return apioperateFullCommissionApproval(data).then((res) => {
                  return res;
              }).catch(err => {
                console.log('err: ', err)
              })
        },
        apicommissionApplyById(context,data){
            console.log(data)
            // debugger;
            return apicommissionApplyById(data).then((res) =>{
            //   console.log('ss');
                return res.data;
            })
            .catch(err => {
              console.log('err: ', err)
            })
        }
    }
}